export default {
  showError: null,
  errorMessage: null,
  errorTitle: null,
  redirectPageOnError: null,
  redirectPageOnErrorMessage: null,
  blockEmailSubmission: null
};



// WEBPACK FOOTER //
// ./src/store/modules/errors/state.js